/**
 * parseLiveBytes – convert an admin-entered "Live Bytes" string into a byte array.
 *
 * Rules:
 *   • Each letter → its ASCII byte code.
 *   • Each run of consecutive digits → a single numeric byte (kept as one unit).
 *
 * Examples:
 *   "W7"   → [87, 7]
 *   "W13"  → [87, 13]
 *   "WMT2" → [87, 77, 84, 2]
 *
 * Numeric runs are clamped to a valid byte range (0–255).
 */
export function parseLiveBytes(str) {
    if (!str) return []
    // Tokenize into runs of digits or single non-digit characters.
    const tokens = String(str).match(/\d+|\D/g) || []
    return tokens.map((token) =>
        /^\d+$/.test(token)
            ? Math.min(255, parseInt(token, 10))
            : token.charCodeAt(0)
    )
}
